export * from './parse-to-entries';
export * from './parse-to-properties';
export * from './stringify';

// Export everything this module exports as a default export
export default exports;
